module.exports = __webpack_public_path__ + "static/media/LD_Lutte_contre_blanchiment_argent_financement_terrorisme_PADM.1b280372.pdf";